import { iso31661 } from 'iso-3166';

import { createLocationOptionsGetter } from '../LocationOptionHelpers/LocationOptionHelpers';
import { getProvinceOptions } from '../Provinces/Provinces';
import { SelectOption } from '../SelectOption/SelectOption';
import { getStateOptions } from '../States/States';

interface CountryType {
    name: string;
    isoCode: string;
}

export const STATE_PROVINCE_REQUIRED_COUNTRIES = [ 'USA', 'CAN' ];

export const getStateProvinceOptions = (countryValue?: string, labelType: 'name' | 'isoCode' = 'name'): SelectOption[] => {
    if (countryValue === 'USA') return getStateOptions(labelType);
    if (countryValue === 'CAN') return getProvinceOptions(labelType);

    return [];
};

const countryMap: Record<string, CountryType> = Object.fromEntries(
    iso31661.map(country => [ country.alpha3, { name: country.name, isoCode: country.alpha3 } ])
);

export const getCountryOptions = createLocationOptionsGetter(countryMap);

export default countryMap;